"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UBO = void 0;
const utils_1 = require("@daytrip/utils");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const Address_1 = require("./Address");
const Birthplace_1 = require("./Birthplace");
let UBO = class UBO {
    id;
    firstName;
    lastName;
    address = new Address_1.MangopayBaseAddress();
    nationalityCountryISOCode;
    birthdayAt;
    birtplace = new Birthplace_1.Birthplace();
    isActive;
};
exports.UBO = UBO;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UBO.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((ubo) => !!ubo.isActive),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UBO.prototype, "firstName", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((ubo) => !!ubo.isActive),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UBO.prototype, "lastName", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((ubo) => !!ubo.isActive),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => Address_1.MangopayBaseAddress),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Address_1.MangopayBaseAddress)
], UBO.prototype, "address", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((ubo) => !!ubo.isActive),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], UBO.prototype, "nationalityCountryISOCode", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((ubo) => !!ubo.isActive),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : new Date(value))),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], UBO.prototype, "birthdayAt", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((ubo) => !!ubo.isActive),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => Birthplace_1.Birthplace),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Birthplace_1.Birthplace)
], UBO.prototype, "birtplace", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], UBO.prototype, "isActive", void 0);
exports.UBO = UBO = __decorate([
    (0, class_transformer_1.Exclude)()
], UBO);
//# sourceMappingURL=UBO.js.map